import {Stack, Typography} from "@mui/material";
import TextWithIcon from "../TextWithIcon";
import {FiCode, FiHash, FiPackage, FiRefreshCw} from "react-icons/fi";
import {useTheme} from "@mui/material";
import {PRODUCT_SYNC_TYPE_OPTIONS} from "../../constants/searchFields";

const getSyncTypeLabel = (value) => PRODUCT_SYNC_TYPE_OPTIONS.find((option) => option.value === value)?.label || value || "-";

const ProductInfo = ({product}) => {
  const theme = useTheme();
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center">
        <TextWithIcon
          Icon={FiPackage}
          text={product?.name || "Producto sin nombre"}
          variant="h5"
          color={theme.palette.text.primary}
        />
      </Stack>
      <Typography variant="body1" color={theme.palette.text.primary}>
        <TextWithIcon Icon={FiCode} text={`${product?.code || "-"}`} />
      </Typography>
      <TextWithIcon Icon={FiHash} text={`${product?.id || "-"}`} />
      <Typography variant="body1" color={theme.palette.text.primary}>
        {product?.description || "Sin descripción"}
      </Typography>
      <Typography variant="body1" color={theme.palette.text.primary}>
        <TextWithIcon Icon={FiRefreshCw} text={getSyncTypeLabel(product?.sync_type)} />
      </Typography>
    </Stack>
  );
};

export default ProductInfo;
